"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackBasket = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackBasket(cart) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        Basket: cart.items.map(item => ({
            category: item.product.trackingPath.join('/'),
            productId: item.product.id,
            productSKU: item.product.manufacturerSku,
            quantities: item.quantity,
            unitPrices: item.product.price.gross.amount,
        })),
    });
}
exports.trackBasket = trackBasket;
//# sourceMappingURL=trackBasket.js.map